<template>
  <div>
    <BaseButton theme="gray" @click="modalOpened = true">
          <span class="inline-flex items-center mt-1 mx-2">
            <font-awesome-icon :icon="['fab', 'youtube']" class="mr-4 text-xxl"/>
            {{ $t('btnLabel') }}
          </span>
    </BaseButton>
    <transition name="modal">
      <CustomModal v-if="modalOpened"
                   position="absolute"
                   @close="modalOpened = false">
        <template v-slot:header>
          <div class="text-xl font-bold text-text leading-tight mb-4 pt-0">
            {{ $t('modalTitle') }}
          </div>
        </template>
        <template v-slot:body>
          <iframe class="video-tour-frame" src="https://www.youtube.com/embed/wam3s31FgK0" title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </template>
      </CustomModal>
    </transition>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import CustomModal from "@/components/UI/modals/CustomModal";

export default {
  name: "WizardVideoTour",
  components: {CustomModal, BaseButton},
  data() {
    return {
      modalOpened: false
    }
  },
  watch: {
    modalOpened(val) {
      if (val) {
        document.querySelector('body').classList.add('overflow-hidden');
      } else {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    }
  },
  i18n: {
    messages: {
      en: {
        btnLabel: 'Videotour',
        modalTitle: 'Videotour'
      },
      ru: {
        btnLabel: 'Видеотур',
        modalTitle: 'Видеотур'
      }
    }
  }
}
</script>

<style lang="scss">
.video-tour-frame {
  width: 660px;
  height: 470px;
  @media(min-width: 1200px) {
    width: 1000px;
    height: 500px;
  }
}
</style>